(() => {
  const MODAL_SELECTOR = '[data-find-your-sofa-modal]';
  const TRIGGER_SELECTOR = 'a[href="#find-your-sofa"]';
  const STEP_DELAY = 180;

  function initModal(modal) {
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    const form = modal.querySelector('[data-find-your-sofa-form]');
    const steps = [...modal.querySelectorAll('[data-find-step]')];
    const prev = modal.querySelector('[data-find-prev]');
    const validation = modal.querySelector('[data-find-validation]');
    const nav = modal.querySelector('[data-find-nav]');
    const results = modal.querySelector('[data-find-results]');
    const resultCopy = modal.querySelector('[data-find-results-copy]');
const restartButtons = modal.querySelectorAll('[data-find-restart]');
    const progressLabel = modal.querySelector('[data-find-progress-label]');
    const progressPercent = modal.querySelector('[data-find-progress-percent]');
    const progressBar = modal.querySelector('[data-find-progress-bar]');
    const productCards = [...modal.querySelectorAll('[data-find-product]')];
    const configJSON = modal.querySelector('[data-find-your-sofa-config]');
const emptyState = modal.querySelector('[data-find-empty]');
const resultsHead = modal.querySelector('.pod-find-sofa__results-head');
const resultsCta = modal.querySelector('.pod-find-sofa__results-cta');
const resultGrid = modal.querySelector('[data-find-result-grid]');
    let config = { resultLimit: 6 };
    let currentStep = 0;
    let previousFocus = null;
    let changingStep = false;

    try {
      config = {
        ...config,
        ...JSON.parse(configJSON?.textContent || '{}')
      };
    } catch (error) {
      console.error('Find Your Sofa config JSON is invalid.', error);
    }

    const selected = name =>
      form.querySelector(`[name="${name}"]:checked`)?.value || '';

    function parseData(value) {
      if (!value) return [];

      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [value];
      }
    }

    function matchesValue(productValue, answer) {
      return parseData(productValue).includes(answer);
    }

    function getAnswers() {
      return {
        shape: selected('shape'),
        room: selected('room'),
        style: selected('style')
      };
    }

    function getRecommendations() {
      const answers = getAnswers();
      const maxResults = Math.max(
        6,
        Math.min(Number(config.resultLimit || 6), 8)
      );

      return productCards
        .filter(card =>
          matchesValue(card.dataset.shape, answers.shape) &&
          matchesValue(card.dataset.room, answers.room) &&
          matchesValue(card.dataset.style, answers.style)
        )
        .slice(0, maxResults);
    }

    function updateProgress() {
      const question = currentStep + 1;
      const percent = Math.round((question / steps.length) * 100);

      if (progressLabel) {
        progressLabel.textContent =
          `Question ${question} of ${steps.length}`;
      }

      if (progressPercent) {
        progressPercent.textContent = `${percent}%`;
      }

      if (progressBar) {
        progressBar.style.width = `${percent}%`;
      }
    }

    function showStep(index) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach((step, i) => {
        const active = i === currentStep;

        step.hidden = !active;
        step.classList.toggle('is-active', active);
        step.classList.remove('is-leaving');
      });

      if (prev) {
        prev.hidden = currentStep === 0;
      }

      if (validation) {
        validation.textContent = '';
      }

      updateProgress();
    }

    function goToNextStep() {
      if (changingStep) return;

      const current = steps[currentStep];
      if (!current) return;

      changingStep = true;
      current.classList.add('is-leaving');

      window.setTimeout(() => {
        if (currentStep < steps.length - 1) {
          showStep(currentStep + 1);
          changingStep = false;
        } else {
          renderResults();
          changingStep = false;
        }
      }, STEP_DELAY);
    }

    function hideAllProducts() {
      productCards.forEach(card => {
        card.hidden = true;
      });
    }

    function renderResults() {
  const recommendations = getRecommendations();

  hideAllProducts();

  form.hidden = true;
  nav.hidden = true;
  results.hidden = false;

  modal.classList.add('is-results');

  if (progressLabel) {
    progressLabel.textContent = 'Your shortlist';
  }

  if (progressPercent) {
    progressPercent.textContent = '100%';
  }

  if (progressBar) {
    progressBar.style.width = '100%';
  }

  // No results
  if (!recommendations.length) {
    modal.classList.add('is-no-results');

    if (resultsHead) resultsHead.hidden = true;
    if (resultGrid) resultGrid.hidden = true;
    if (resultsCta) resultsCta.hidden = true;
    if (emptyState) emptyState.hidden = false;

    return;
  }

  // Results found
  modal.classList.remove('is-no-results');

  if (resultsHead) resultsHead.hidden = false;
  if (resultGrid) resultGrid.hidden = false;
  if (resultsCta) resultsCta.hidden = false;
  if (emptyState) emptyState.hidden = true;

  recommendations.forEach(card => {
    card.hidden = false;
  });

  if (resultCopy) {
    resultCopy.textContent =
      `We found ${recommendations.length} sofa${
        recommendations.length === 1 ? '' : 's'
      } matching the shape, room size and style you selected.`;
  }
}

    function resetQuiz() {
      form.reset();
      hideAllProducts();

      modal.classList.remove('is-results');
      results.hidden = true;
      form.hidden = false;
      nav.hidden = false;
modal.classList.remove('is-results');
modal.classList.remove('is-no-results');
if (emptyState) emptyState.hidden = true;
if (resultsHead) resultsHead.hidden = false;
if (resultGrid) resultGrid.hidden = false;
if (resultsCta) resultsCta.hidden = false;
      showStep(0);
    }

    function openModal(trigger) {
      previousFocus = trigger || document.activeElement;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pod-find-sofa-open');

      window.setTimeout(() => {
        modal.querySelector('[data-find-your-sofa-close]')?.focus();
      }, 20);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('pod-find-sofa-open');

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    form?.addEventListener('change', event => {
      if (!event.target.matches('input[type="radio"]')) return;

      if (validation) {
        validation.textContent = '';
      }

      goToNextStep();
    });

    prev?.addEventListener('click', () => {
      showStep(currentStep - 1);
    });

restartButtons.forEach(button => {
  button.addEventListener('click', resetQuiz);
});
    modal
      .querySelectorAll('[data-find-your-sofa-close]')
      .forEach(button => {
        button.addEventListener('click', closeModal);
      });

    document.addEventListener('click', event => {
      const trigger = event.target.closest(TRIGGER_SELECTOR);

      if (!trigger) return;

      event.preventDefault();
      openModal(trigger);
    });

    document.addEventListener('keydown', event => {
      if (
        modal.classList.contains('is-open') &&
        event.key === 'Escape'
      ) {
        closeModal();
      }
    });

    hideAllProducts();
    showStep(0);
  }

  function init(root = document) {
    const modal =
      root.querySelector?.(MODAL_SELECTOR) ||
      document.querySelector(MODAL_SELECTOR);

    if (modal) {
      initModal(modal);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });
})();